import { request } from 'shared/lib/request';

export const saveChangesForAdditionalUsersService = ({ additionalUsers }) =>
  request.post('/me/manage-access', { additionalUsers });
